function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowandBow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M60.0581 4.91235H26.4915V42.9124H60.0581V4.91235Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8914 8.07905H29.6581V39.7457H56.8914V8.07905Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6248 36.579L60.0581 42.9124V4.91235L74.6248 8.07902V36.579Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5914 8.05689L72.0914 10.1216V34.9166L62.5914 39.0491V8.05689Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9248 36.579L26.4915 42.9124V4.91235L11.9248 8.07902V36.579Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4581 34.9166V10.1216L23.9581 8.05689V39.0491L14.4581 34.9166Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4915 4.91235H60.0581M26.4915 4.91235V42.9124M26.4915 4.91235L11.9248 8.07902V36.579L26.4915 42.9124M60.0581 4.91235V42.9124M60.0581 4.91235L74.6248 8.07902V36.579L60.0581 42.9124M60.0581 42.9124H26.4915M29.6581 8.07905H56.8914V39.7457H29.6581V8.07905ZM62.5914 8.05689L72.0914 10.1216V34.9166L62.5914 39.0491V8.05689ZM14.4581 34.9166V10.1216L23.9581 8.05689V39.0491L14.4581 34.9166Z",
    stroke: "#1D1D1B",
    style: {
      stroke: "#1D1D1B",
      stroke: "color(display-p3 0.1137 0.1137 0.1059)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowandBow);
export default __webpack_public_path__ + "static/media/Bow and Bow.07f8792574019a12d849cad1e9b4cea9.svg";
export { ForwardRef as ReactComponent };